<template>
    <div class="row align-items-end">
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Atanma Durumu</label>
            <v-select-list :options="types" label="Name" v-model="type" placeholder="Atanma Durumu"></v-select-list>
        </div>
        <div class="col-auto">
            <button class="btn btn-secondary" v-on:click="$emit('filter',filterData)">Filtrele</button>
        </div>
        <div class="col-auto">
            <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            types:[
                {Name:'TÜMÜ',Value:null},
                {Name:'AKTİF ATAMA DEVAM EDİYOR',Value:true},
                {Name:'ATAMA SÜRESİ DOLMUŞ',Value:false}
            ],
            filterData:{
                AssignmentExpired:null
            }
        }
    },
    methods:{
        clearForm(){
            this.filterData.AssignmentExpired = null
            this.$emit('filter',this.AssignmentExpired)
        },
    },
    computed:{
        type:{
            get(){
                return this.types.find(b=>b.Value==this.filterData.AssignmentExpired)
            },
            set:function(value){
                this.filterData.AssignmentExpired = value?.Value
            }
        }
    }
}
</script>